<template>
  <div class="shop-settings-field-list">
    <template v-for="(fields, sectionTitle) of fields">
      <SectionTitleField :label="sectionTitle" :key="`${sectionTitle}-title`" />
      <ShopSettingsField
        v-for="field of fields"
        :key="field.label"
        :field="field"
        @dirtied="stageEdit({ fieldName: field.name, changes: $event })"
        @cleaned="unstageEdit(field.name)"
        @update="stageEdit({ fieldName: field.name, changes: $event })"
        :is-scroll-target="shopSettingsScrollTarget === slugMe(field.label)"
        @save="$emit('save')"
      />
    </template>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapActions } from 'vuex'

import slugMe from '@/utils/slugMe'

import ShopSettingsField from '@/components/ShopSettingsField'
import SectionTitleField from '@/components/SectionTitleField'

export default {
  name: 'ShopSettingsFieldList',
  components: {
    ShopSettingsField,
    SectionTitleField,
  },
  props: {
    fields: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  mounted() {
    if (this.$route.hash) {
      setTimeout(() => {
        this.$scrollTo(this.$route.hash, 700, { offset: -65 })
      }, 1300)
    }
  },
  methods: {
    ...mapActions('shop', ['stageEdit', 'unstageEdit']),
    slugMe,
  },
  computed: {
    ...mapFields('admin', ['shopSettingsScrollTarget']),
  },
}
</script>
